import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setLanguage } from 'redux-i18n';
import moment from 'moment';
import base64 from 'base-64';

import {
  BOOKING_STEP,
  getBookingDetail,
  injectGoogleMaps,
  sendBookingDetailLink,
  sendGTMEvents,
  setBookEmail,
  setBookLocator,
  setStep,
  bookingAdyenPay,
} from '../../../actions/Booking';
import { CALL_CENTER_ROLE, TPV_FORM_ADYEN } from '../../../constants';
import { paymentCreatedEvent, sendSimpleGAEvent } from '../../../events/Booking';

import CallCenterBookingOptions from './CallCenterBookingOptions';
import BookingLoadingScreen from './BookingLoadingScreen';
import PromoCodeDetail from '../rooms/PromoCodeDetail';

import '../../../static/less/pages/booking_details.less';
import '../../../static/images/mapicohotel.png';
import '../../../static/images/loading4.gif';

import DsMap from '../../ds/atoms/map';
import DsBannerThanks from '../../ds/molecules/banner/bannerThanks';
import DsSection from '../../ds/molecules/DsSection';
import DsHotelCard from '../../ds/organism/Card/CardHotel';
import MyBookingTab from '../../ds/organism/STab/mybooking/myBookingTab';
import DsTimelinePurchase from '../../ds/pages/MyBooking/TimelinePurchase';
import DsCancellation from '../../ds/pages/MyBooking/Cancellation';
import DsLoadingScreen from '../../ds/atoms/loading/index';
import Transfers from '../Transfers';
import DSBannerBecomeLoyaltyMember from '../../loyalty/DSBannerBecomeLoyaltyMember';
import '../../../static/less/rooms/complete_adyen_payment.less';
import withNavigate from '../../../withNavigate'; // Importa el HOC

class BookingDetailsPrev extends React.Component {
  constructor(props) {
    super(props);
    const query = new URLSearchParams(this.props.location.search);

    this.state = {
      booking: null,
      adyenInitialized: false,
      pageStatus: 'loading',
      guestEditModal: { show: false },
      active: 'Rooms',
      roomGuests: [],
      query,
      showCompleteAdyenPayment: false,
    };
    this.buildShareVoucherLink = this.buildShareVoucherLink.bind(this);
    this.createAdyenWidget = this.createAdyenWidget.bind(this);
  }

  async componentDidUpdate() {
    const { booking, adyenInitialized } = this.state;
    const isBookingPending = this.isBookingPending();

    if (isBookingPending && booking.locator && booking.cli_email
      && !adyenInitialized && booking.payment_external_method === 'ADYEN') {
      this.setState({ showCompleteAdyenPayment: true });
      await this.createAdyenWidget(booking.locator, booking.cli_email);
    }
  }

  componentDidMount() {
    let locator;
    let email;
    let lang;
    const { params } = this.props;

    if (params && params.locator && params.email) {
      locator = base64.decode(params.locator);
      email = base64.decode(params.email);
      lang = params.lang;
    } else if (this.props.locator && this.props.email) {
      locator = this.props.locator;
      email = this.props.email;
      lang = this.props.lang;
    }

    if (locator && email) {
      if (lang && lang !== this.props.lang) {
        this.props.dispatch(setLanguage(lang));
        moment.locale(lang);
      }
      this.loadBooking(locator, email, lang);
      this.props.dispatch(setStep(BOOKING_STEP.NO_AVAIL_STEP));
      this.props.dispatch(injectGoogleMaps());
    } else {
      this.props.navigate('/');
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    const { lang } = nextProps;
    if (lang !== this.props.lang) {
      this.loadBooking(nextProps.locator, nextProps.email, lang);
      moment.locale(lang);
    }
  }

  loadBooking(locator, email, lang) {
    this.setState({ pageStatus: 'loading', booking: null });
    this.props.dispatch(getBookingDetail(lang, locator, 'email', email)).then((response) => {
      const { booking } = response;
      if (booking) {
        this.props.dispatch(setBookLocator(locator));
        this.props.dispatch(setBookEmail(email));
        this.onBookLoaded(booking);
      } else {
        this.setState({ pageStatus: 'error' });
      }
    });
  }

  async createAdyenWidget(locator, email) {
    if (this.state.adyenInitialized) return;
    this.setState({ adyenInitialized: true });
    try {
      const result = await this.props.dispatch(bookingAdyenPay(
        this.context,
        locator,
        email,
        TPV_FORM_ADYEN,
        this.props.navigate,
      ));

      if (result === 'ERR') {
        // eslint-disable-next-line no-console
        console.error('Error processing booking with Adyen.');
      } else {
        // eslint-disable-next-line no-console
        console.log('Adyen payment initialized successfully.');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error in createAdyenWidget:', error);
    }
  }

  renderTransfer(booking) {
    const { transfer } = booking; // eslint-disable
    if (!transfer) {
      return null;
    }

    const room = booking.rooms[0];
    const occupancy = this.getCombinedOccupancy(booking);
    return (
            <div className="row ThanksTransfers">
              <Transfers
                      checkin={room.check_in} checkout={room.check_out}
                      locator={booking.locator} lang={this.props.lang}
                      occupancy={occupancy} {...transfer} />
              <p>
                {this.context.t('You can also find bookable transfers in the email we just sent you')}
              </p>
            </div>
    );
  }

  onBookLoaded(booking) {
    let uniqueSeq = 0;
    const roomGuests = booking.rooms.map((room, roomIndex) => room.occupants.map((occupant, occupantIndex) => {
      const nameTokens = occupant.name.replace(/\s+/g, ' ').split(' ');
      uniqueSeq += 1;
      return {
        // Fields that cannot be changed
        age: occupant.age,
        ptype: occupant.ptype,
        code: occupant.code,

        // Fields that identify the guest
        roomIndex,
        guestIndex: occupantIndex,
        uniqueSeq,

        // Editable fields
        idType: 'email',
        userId: '',
        name: nameTokens[0],
        surname: nameTokens[1],
        surname2: nameTokens[2],
      };
    }));
    this.setState({ booking, roomGuests, pageStatus: booking.status === 'PEND' ? 'pending' : false });

    const isNewBooking = this.props.showThanks && !this.isBookingCancelled();

    if (isNewBooking) {
      try {
        const paymentEvent = paymentCreatedEvent(booking);
        this.props.dispatch(sendGTMEvents([paymentEvent], `Purchase Event: ${booking.locator}`));
      } catch (e) {
        Raven.captureException(`Purchase Event: ${booking.locator} : ${e}`);
      }
    }
  }

  isBookingCancelled() {
    const { booking } = this.state;
    if (!booking) {
      return false;
    }
    return booking.status === 'CANC' || booking.status === 'REV';
  }

  isBookingPending() {
    const { booking } = this.state;
    if (!booking) {
      return false;
    }
    return booking.status === 'PEND';
  }

  goToCancellation = () => {
    sendSimpleGAEvent('Cancel', 'Go to cancellation');
    this.props.navigate('/cancellation/');
  };

  /* eslint-disable max-len */
  shareVoucher = (url, email) => this.props.dispatch(sendBookingDetailLink(this.props.locator, this.props.email, email, this.props.lang))

  /* eslint-enable max-len */

  buildShareVoucherLink() {
    const baseURL = process.env[`${this.props.chain}_BOOKING`];
    let url = null;
    if (this.props.locator && this.props.email) {
      const locator = base64.encode(this.props.locator);
      const email = base64.encode(this.props.email);
      url = `${baseURL}/booking-detail/${locator}/${email}/${this.props.lang}/`;
    }
    return Promise.resolve(url || `${baseURL}/my-booking/`);
  }

  //****
  //**** RENDER*/
  //****

  renderMap(booking) {
    const hasLocation = booking && booking.hotel.position.latitude;
    if (!hasLocation) {
      return null;
    }
    const { latitude, longitude } = booking.hotel.position;
    return <DsMap latitude={latitude} longitude={longitude} className="h-40 w-40"/>;
  }

  renderCallCenterOptions(booking) {
    if (!this.props.isCallCenterUser) {
      return null;
    }
    return (
            <CallCenterBookingOptions booking={booking} locator={this.props.locator} lang={this.props.lang}/>
    );
  }

  onClose = () => {
    this.setState({ showCompleteAdyenPayment: false });
  };

  rendershowCompleteAdyenPaymentPayment() {
    const { showCompleteAdyenPayment } = this.state;
    if (showCompleteAdyenPayment === true) {
      return (
        // eslint-disable-next-line react/no-string-refs
        <div className="CompleteAdyenPayment animated bounceInLeft" ref="CompleteAdyenPayment"
        onClick={this.onClose}>
          <b>{this.context.t('The payment has not been completed. Please verify your information and try again.')}</b>
        </div>
      );
    }
    return null;
  }

  render() {
    const isNewBooking = this.props.showThanks && !this.isBookingCancelled();
    const {
      pageStatus, booking, query,
    } = this.state;
    const {
      email, locator, lang, chain,
    } = this.props;
    const isLoading = pageStatus === 'loading';

    if (isLoading) {
      return (
              <DsLoadingScreen chain={chain}>
                <p>{this.context.t('Retrieving your booking...')}</p>
              </DsLoadingScreen>
      );
    }
    if (!booking) {
      return (
              <BookingLoadingScreen
                      mode={pageStatus}
                      onClickPay={this.goToPayment}
                      onClickCancel={this.goToCancellation}
                      onClickReload={this.loadBooking}
                      callCenterPhones={this.state.booking ? this.state.booking.hotel.chain.call_center_phones : null}
              />);
    }
    const bookingEngineCfg = this.props.chainData.booking_engine_configuration;
    return (
            <div className="container">
              <DsSection title={this.context.t('Booking Summary')} bookingReference={booking.locator} booking={booking}>
                {this.rendershowCompleteAdyenPaymentPayment()}
                {isNewBooking && <DsBannerThanks
                        booking={booking}
                        lang={lang}
                        loyalty={bookingEngineCfg}
                        loggedUser={this.props.loggedUser}
                />}
                {!isNewBooking && !this.props.loggedUser && <DSBannerBecomeLoyaltyMember
                        coins={booking.loyalty.checkout_coins || 0}
                        lang={lang}
                        loyalty={bookingEngineCfg}
                        loggedUser={this.props.loggedUser}/>}
                <h5 className="text-2xl text-danger-200 text-left uppercase font-bold">
                  {
                    this.isBookingPending() && booking.payment_method_code === 'ADYEN'
                    && this.context.t('Pay now to confirm your booking')
                  }
                </h5>
                <div id="dropin-container" className="py-3"></div>
                <div className="flex -mx-2 flex-wrap lg:flex-nowrap">
                  <DsHotelCard
                          className="mb-4 lg:max-w-xxs flex-grow-default mx-2 order-2 md:order-1"
                          booking={booking}
                          email={email}
                          locator={locator}
                          lang={lang}
                  />
                  <MyBookingTab className="mb-8 md:mb-4 mx-2 flex-grow-default order-1"
                                booking={booking}
                                query={query}
                                lang={lang}
                                chain={chain}
                                buildUrl={this.buildShareVoucherLink}
                                onShare={this.shareVoucher}
                                loyalty={bookingEngineCfg}/>
                  {/*{isNewBooking && this.renderTransfer(booking)}*/}
                </div>
                {this.renderCallCenterOptions(booking)}
                <div className="mx-4">
                  <DsTimelinePurchase booking={booking}/>
                  <DsCancellation booking={booking} onClick={this.goToCancellation}/>
                </div>
                {booking.promoCode && (
                        <PromoCodeDetail code={booking.promoCode}
                                         description={booking.promocode_description || ''}/>)}
              </DsSection>
            </div>
    );
  }
}

BookingDetailsPrev.propTypes = {
  showThanks: PropTypes.bool,
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

BookingDetailsPrev.contextTypes = {
  t: PropTypes.func.isRequired,
};

BookingDetailsPrev.defaultProps = {
  showThanks: false,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  locator: state.booking.book_locator,
  email: state.booking.book_email,
  booking: state.booking.bookData,
  lang: state.i18nState.lang,
  cartHotel: state.cart.cartHotel,
  device: state.booking.device,
  utmParams: state.bookingFormState.utmParams || {},
  chain: state.bookingFormState.chain,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  chainData: state.session.chainData,
  loggedUser: state.loyalty.loggedUser,
});

const ConnectedBookingDetailsPrev = connect(mapStateToProps)(BookingDetailsPrev);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedBookingDetailsPrev);
